import { render, staticRenderFns } from "./kardex-student-view.vue?vue&type=template&id=3d2658a4&"
import script from "./kardex-student-view.vue?vue&type=script&lang=js&"
export * from "./kardex-student-view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports